import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import AdminPartnerInvites from "../widgets/adminPartnerInvites";
import AdminSharedInvites from "../widgets/adminSharedInvites";
import AdminSingleInvites from "../widgets/adminSingleInvites";
import InviteReports from "../widgets/inviteReports";

const InvitePortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Invites" />
      <PortalGridContent>
        <Grid item xs={12} sm={12} md={6}>
          <AdminSingleInvites />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminSharedInvites />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AdminPartnerInvites />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <InviteReports />
        </Grid>
        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(InvitePortal);
